
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    HACKMOTIONREPORT_ACTION,
    ALL_HACKMOTIONREPORT,
    ADD_HACKMOTIONREPORT,
    DELETE_HACKMOTIONREPORT,
    EDIT_HACKMOTIONREPORT
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * HACKMOTION SESSION Actions
 */

    export const allHackmotionReport = () =>{    
    
        return (dispatch) => { 
            dispatch({ type: HACKMOTIONREPORT_ACTION });
            return axios.get(AppConfig.apiurl+'/api/gettqhackmotionreport', { headers: AuthHeader.header })         
            .then(response => {             
                const alldata=response.data.data;
                dispatch({ type: ALL_HACKMOTIONREPORT, payload: alldata });
            });
        }        
    
    }

    export const addHackmotionReport = (data, selfile) =>{
    
        var payload={
            "student":data.target.student.value,
            "date":data.target.seldate.value,
            "reportname":data.target.reportname.value,
            "fileupl":selfile,
        }
        return (dispatch) => { 
            dispatch({ type:HACKMOTIONREPORT_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/uploadtqhackmotionreport', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allHackmotionReport()(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_HACKMOTIONREPORT});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }    


    export const deleteHackmotionReport = (id) =>{
    
        var payload={
            "id":id
        }
        return (dispatch) => { 
            dispatch({ type:HACKMOTIONREPORT_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deletetqhackmotionreport', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    allHackmotionReport()(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_HACKMOTIONREPORT});                    
                }                
                
            });
        
        }
    }

    export const editHackmotionReport = (data) => {
        const payload = {
            student: data.target.student,
            date: data.target.seldate,
            reportname: data.target.reportname,
            fileupl: data.target.fileupl,
            oldfiles: data.oldfiles,
            id: data.id 
        };
    
        return (dispatch) => {
            dispatch({ type: HACKMOTIONREPORT_ACTION });
            return axios.post(`${AppConfig.apiurl}/api/edittqhackmotionreport`, payload, { headers: AuthHeader.header })
                .then(response => {
                    const resdata = response.data;
                    if (resdata.status === 1) {
                        allHackmotionReport()(dispatch);
                        NotificationManager.success(resdata.message);
                        dispatch({ type: EDIT_HACKMOTIONREPORT, payload: resdata });
                    } else {
                        NotificationManager.error('Unsuccessful API call');
                    }
                })
                .catch(error => {
                    NotificationManager.error('Error: ' + error.message);
                });
        };
    };
    
   

